import type { PlayerRef, TPlayer } from '@setplex/pureya'
import type { LAProps, NpawPlayerOptions } from '~/features/npaw'
import type { NpawPlugin } from '../index.h'

import { useEffect, useState } from 'react'
import { logger } from '~/shared/logger'
import { initNpawPlugin } from '../model'

export function useNpaw({
  npawData,
  on,
  playerInstance,
  enable = false,
  drm,
}: {
  npawData: NpawPlayerOptions | null
  enable?: boolean
  drm?: { la: LAProps }
  on?: PlayerRef['on']
  playerInstance?: TPlayer | null
}) {
  const [npawPlugin, setNpawPlugin] = useState<NpawPlugin | null>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (npawPlugin) return

    if (enable && npawData && playerInstance && isReady) {
      const { options_ } = playerInstance ?? {}
      const sourceUrl = playerInstance.currentSrc()

      const video = {
        ...options_,
        sourceUrl,
        drm,
      }

      try {
        setNpawPlugin(initNpawPlugin(playerInstance, npawData, video))
      } catch (e) {
        logger.error('initNpawPlugin issue: ', e)
      }
    }
  }, [drm, enable, isReady, npawData, npawPlugin, playerInstance])

  if (!on) return

  //
  // listen on player events
  //

  on('ready:npaw', () => setIsReady(true))

  on('dispose:npaw', () => {
    if (npawPlugin) {
      npawPlugin.removeAdapter()
      setNpawPlugin(null)
      setIsReady(false)
    }
  })
}
